import { getNotificationsCountAndDataApi, getHelloBarDetailsApi, putHelloBarDetailsApi } from 'api/notifications';
import NotificationModel from 'models/notification';

export function getNotificationsCountAndData({ latestPullNotificationId, offset = 0, limit = 10, callType }) {
  return getNotificationsCountAndDataApi({
    latestPullNotificationId,
    offset,
    limit,
    callType,
  }).then((res) => {
    const count = res.entity.unreadCount;
    const data = res.entity.notifications.map((json) => {
      const notification = new NotificationModel();
      notification.fromJSON(json);
      return notification;
    });
    return { count, data };
  });
}

export const getHelloBarDetails = ({ pageType }) => getHelloBarDetailsApi({ pageType }).then((res) => res.entity);

export const putHelloBarDetails = ({ pageType }) => putHelloBarDetailsApi({ pageType }).then((res) => res.entity);
